///<reference path="newphotoselection/newphotoselection.component.ts"/>
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { CartComponent } from './cart/cart.component';
import { ProductComponent } from './product/product.component';
import { OnlinePhotoOrderComponent } from './online-photo-order/online-photo-order.component';
import { FooterComponent } from './footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ServicesService } from './services.service';
import { MatTableModule } from '@angular/material';
import { MatPaginatorModule } from '@angular/material/paginator';

import { Select2Module } from 'ng2-select2';
import { MatAutocompleteModule, MatInputModule } from '@angular/material';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';
import { PhotoSelectionComponent } from './photo-selection/photo-selection.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MyordersComponent } from './myorders/myorders.component';
import { OrderdetailComponent } from './orderdetail/orderdetail.component';
import { HeaderComponent } from './header/header.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AuthGuard } from './auth/auth.guard';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { CookieService } from 'ngx-cookie-service';
import { OrderProcessingComponent } from './order-processing/order-processing.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { VerifyUserComponent } from './verify-user/verify-user.component';
import { MakePaymentComponent } from './make-payment/make-payment.component';
import { MakePaymentEftComponent } from './make-payment-eft/make-payment-eft.component';
import {NewphotoselectionComponent} from "./newphotoselection/newphotoselection.component";
import { JobPhotoSelectionComponent } from './job-photo-selection/job-photo-selection.component';
import { JobphotosproductsComponent } from './jobphotosproducts/jobphotosproducts.component';
import { SessionLoginComponent } from './session-login/session-login.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    CartComponent,
    ProductComponent,
    OnlinePhotoOrderComponent,
    FooterComponent,
    PhotoSelectionComponent,
    DashboardComponent,
    MyordersComponent,
    OrderdetailComponent,
    HeaderComponent,
    ChangePasswordComponent,
    OrderProcessingComponent,
    ForgetPasswordComponent,
    VerifyUserComponent,
    MakePaymentComponent,
    MakePaymentEftComponent,
    NewphotoselectionComponent,
    JobPhotoSelectionComponent,
    JobphotosproductsComponent,
    SessionLoginComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
      FormsModule,
      ReactiveFormsModule,
      HttpClientModule,
      Select2Module,
      MatInputModule,
      MatAutocompleteModule,
      BrowserAnimationsModule,
      HttpModule,
      MatTableModule,
      MatPaginatorModule,
      SweetAlert2Module.forRoot({
          buttonsStyling: false,
          customClass: 'modal-content',
          confirmButtonClass: 'btn btn-small btn-dark-solid',
          cancelButtonClass: 'btn btn-small btn-dark-solid'
      }),
  ],
  providers: [ServicesService, AuthGuard, CookieService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/app.module.ts